<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu :default-active="'default'" class="el-menu-demo" mode="horizontal">
          <el-menu-item index="default">微博账号监测</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <el-row :gutter="20" style="margin-bottom: 15px">
          <el-col :span="6">
            <el-input size="small" v-model="form.jobName" placeholder="监测任务名称" @keyup.enter.native="startSearch"></el-input>
          </el-col>
          <el-col :span="6">
            <el-input size="small" v-model="form.queryString" placeholder="账号名称/链接" @keyup.enter.native="startSearch"></el-input>
          </el-col>
          <el-col :span="6" class="input-group">
            <el-date-picker v-model="form.startTime" type="date" placeholder="起始监测时间" size="small" value-format="yyyy-MM-dd 00:00:00" :picker-options="pickerMin">
            </el-date-picker>
            <span>~</span>
            <el-date-picker v-model="form.endTime" type="date" placeholder="截止监测时间" size="small" value-format="yyyy-MM-dd 23:59:59" :picker-options="pickerMax">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.status" clearable class="w-100" size="small" placeholder="全部状态">
              <el-option v-for="(label, value) in mediaConfig.getConfigList('monitor_status')" :key="value" :label="label" :value="value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input size="small" v-model="form.createUserName" placeholder="创建人" @keyup.enter.native="startSearch"></el-input>
          </el-col>
          <el-col :offset="12" :span="6" class="text-right">
            <el-button type="default" size="small" @click="resetForm">重置</el-button>
            <el-button type="primary" size="small" @click="startSearch">搜索</el-button>
          </el-col>
        </el-row>

        <div class="monitor-list-title">
          <span>监测任务总数：{{ page.total }}条</span>
          <el-button v-if="remainTaskNum" type="primary" size="mini" icon="el-icon-plus" @click="toAdd">创建监测任务</el-button>
        </div>

        <el-table :data="tableData" v-loading="tableLoading" size="small">
          <el-table-column prop="monitorTaskName" label="监测任务名称" min-width="130px">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.monitorTaskName" placement="bottom-start" effect="light" :popper-class="'overflow-content-tooltip'">
                <div class="task-name">{{ scope.row.monitorTaskName }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="accountName" label="账号名称" min-width="130px">
            <template slot-scope="scope">
              <a v-if="scope.row.accountUrl" class="link" :href="scope.row.accountUrl" target="_blank">{{ scope.row.accountName }}</a>
              <span v-else>{{ scope.row.accountName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="monitorStartTime" label="监测时段" min-width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.monitorStartTime || scope.row.monitorEndTime">
                {{ scope.row.monitorStartTime ? scope.row.monitorStartTime.split(' ')[0] : '' }} ~ {{ scope.row.monitorEndTime ? scope.row.monitorEndTime.split(' ')[0] : '' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人" min-width="90px"></el-table-column>
          <el-table-column prop="monitorSumNum" label="监测次数" min-width="90px"></el-table-column>
          <el-table-column prop="monitorUpdateTime" label="最新更新时间" min-width="130px"></el-table-column>
          <el-table-column prop="monitorStatus" label="监测状态" min-width="90px">
            <template slot-scope="scope">
              {{ mediaConfig.getAppointed("monitor_status", scope.row.monitorStatus, '') }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <el-button v-if="scope.row.monitorStatus == mediaConfig.MonitorStatus.WaitMonitor" type="text" size="small" @click="onEditMonitor(scope.row)">
                调整时段
              </el-button>
              <el-button v-if="scope.row.monitorStatus == mediaConfig.MonitorStatus.InMonitor || scope.row.monitorStatus == mediaConfig.MonitorStatus.CompleteMonitor" type="text" size="small"
                @click="toArticleList(scope.row.monitorTaskUuid, scope.row.id)">
                文章列表
              </el-button>
              <el-button v-if="scope.row.monitorStatus == mediaConfig.MonitorStatus.InMonitor" type="text" size="small" @click="onEndMonitor(scope.row.id)">
                结束监测
              </el-button>
              <el-button v-if="scope.row.monitorStatus == mediaConfig.MonitorStatus.WaitMonitor" type="text" size="small" @click="onDelMonitor($event, scope.row.id)">
                删除
              </el-button>
              <el-button v-if="scope.row.monitorStatus == mediaConfig.MonitorStatus.CompleteMonitor" type="text" size="small" @click="onDelMonitor($event, scope.row.id, '确认删除该监测任务吗？删除后该任务的监测数据无法找回')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
            layout="sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="调整监测任务" :visible.sync="monitorEditModal" width="600px" class="yhg-dialog" @close="jobEditClose">
      <el-form v-loading="editLoading" :model="editForm" ref="editForm" class="job-form" label-width="100px" :rules="rules">
        <el-form-item prop="jobName" label="监测任务">
          <el-input v-model="editForm.jobName" placeholder="监测任务名称" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="rangeTime" label="监测时段" class="select-input-wrap">
          <el-date-picker v-model="editForm.rangeTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="jobRangePicker" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" @blur="jobTimeRangeblur">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="submit-btn-wrap text-center" label-width="0">
          <el-button type="primary" @click="onEditJob">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import { dateFormat } from "@/util/date";
import { mediaConfig } from "@/const/config/media";
import {
  taskList,
  taskNumOver,
  delTask,
  taskNameExist,
  editTask,
  endTask,
} from "@/api/media/monitor";
export default {
  data() {
    var that = this;
    //任务名存在性校验
    var validJobName = (rule, value, callback) => {
      if (value && value.trim()) {
        taskNameExist({ jobName: value.trim(), taskId: this.editForm.jobId })
          .then((res) => {
            if (res.data) {
              callback();
            } else {
              callback(new Error("该监测任务名称已存在"));
            }
          })
          .catch((error) => {
            callback();
          });
      }
    };
    return {
      //搜索表单
      form: {
        jobName: "",
        queryString: "",
        createUserName: "",
        startTime: "",
        endTime: "",
        status: "",
      },
      //列表
      tableLoading: false,
      tableData: [],
      //剩余任务数
      remainTaskNum: 6,
      //任务分页
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      mediaConfig: mediaConfig,

      pickerMin: {
        disabledDate(time) {
          if (validate.checkNull(that.form.endTime)) return false;
          return time.getTime() > new Date(that.form.endTime).getTime();
        },
      },
      pickerMax: {
        disabledDate(time) {
          if (validate.checkNull(that.form.startTime)) return false;
          return time.getTime() < new Date(that.form.startTime).getTime();
        },
      },

      //调整监测时间规则
      timeOptionRange: "",
      jobRangePicker: {
        onPick: (time) => {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          let t = new Date(dateFormat(new Date()).split(" ")[0] + " 00:00:00");
          let timeOptionRange = this.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 6 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() <= t.getTime() ||
              time.getTime() < timeOptionRange.getTime() - secondNum ||
              time.getTime() > timeOptionRange.getTime() + secondNum
            );
          }
          return time.getTime() <= t.getTime();
        },
      },
      //监测调整
      monitorEditModal: false,
      editLoading: false,
      editForm: {
        jobId: "",
        jobName: "",
        startTime: "",
        endTime: "",
        rangeTime: "",
      },
      rules: {
        jobName: [
          { required: true, message: "请输入监测任务名称", trigger: "blur" },
          { validator: validJobName, trigger: "blur" },
        ],
        rangeTime: [
          { required: true, message: "请选择监测时段", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    //重置搜索表单
    resetForm() {
      this.form = {
        jobName: "",
        queryString: "",
        createUserName: "",
        startTime: "",
        endTime: "",
        status: "",
      };
      this.startSearch();
    },
    //搜索
    startSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    //获取任务列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      taskNumOver().then((res) => {
        this.remainTaskNum = res.data || 0;
      });
      taskList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 编辑监测
     * @param obj 监测对象
     */
    onEditMonitor(obj) {
      if (obj) {
        this.editForm.jobId = obj.id;
        this.editForm.jobName = obj.monitorTaskName;
        this.editForm.startTime = obj.monitorStartTime;
        this.editForm.endTime = obj.monitorEndTime;
        this.editForm.rangeTime = [obj.monitorStartTime, obj.monitorEndTime];
        this.monitorEditModal = true;
      } else {
        this.$message.error("数据错误，不可编辑");
      }
    },
    /**
     * 删除监测
     * @param evt 点击事件
     * @param id 任务id
     * @param text 提醒
     */
    onDelMonitor(evt, id, text = "确认删除该监测任务吗？") {
      this.$confirm(text, "确认删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "",
        customClass: "msgbox contnt-center",
      })
        .then(() => {
          delTask({ jobId: id }).then((res) => {
            this.$message.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 结束监测
     * @param id 任务id
     */
    onEndMonitor(id) {
      this.$confirm("确认结束该监测吗？", "结束监测", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "",
        customClass: "msgbox contnt-center",
      })
        .then(() => {
          endTask({ jobId: id }).then((res) => {
            this.$message.success("结束监测成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    //监测调整--弹窗关闭
    jobEditClose() {
      this.$refs.editForm.clearValidate();
    },
    //监测调整--关闭时间选择器
    jobTimeRangeblur() {
      if (!this.form.rangeTime || this.form.rangeTime.length < 2) {
        this.timeOptionRange = "";
      }
    },
    //监测调整--提交修改
    onEditJob() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.editForm.rangeTime.length == 2) {
            this.editForm.startTime = this.editForm.rangeTime[0];
            this.editForm.endTime = this.editForm.rangeTime[1];
            this.editLoading = true;
            editTask(this.editForm)
              .then((res) => {
                this.$message.success("修改成功");
                this.editLoading = false;
                this.monitorEditModal = false;
                this.getList();
              })
              .catch((err) => {
                this.editLoading = false;
              });
          } else {
            this.$message.error("请选择正确的监测时段范围");
            return;
          }
        }
      });
    },
    //跳转--创建监测
    toAdd() {
      this.$router.push({
        path: "/media/weiboAnalysis/add",
      });
    },
    /**
     * 跳转--文章列表
     * @param uuid 任务uuid
     * @param id 任务id
     */
    toArticleList(uuid, id) {
      let router = this.$router.resolve({
        path: "/media/weiboAnalysis/article",
        query: {
          tid: id,
          id: uuid,
        },
      });
      window.open(router.href, "_blank");
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/media/index.scss";
.monitor-list-title {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  font-size: 14px;
}
.task-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.pagination-wrap {
  text-align: right;
}
</style>